import React, { useEffect, useRef, useState } from "react";

import "./photo.scss";
import { observer } from "mobx-react-lite";
import galleryStore from "../../../stores/gallery_store/gallery_store";
import GalleryPhotoAlbum from "./album/album";
import generalStore from "../../../stores/general_store/general_store";

function GalleryPhoto() {
	const getAge = (y: number) => y - (y % 10);

	const albumsWrapperRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (galleryStore.galleryPhotoAlbums) {
			scrollToEvent(getAge(galleryStore.galleryPhotoAlbums[0].year));
			let ages: number[] = [];
			galleryStore.galleryPhotoAlbums.map((album) =>
				ages.push(getAge(album.year))
			);
			ages = Array.from(new Set(ages)).sort();
			generalStore.ages = ages;
		}
	}, [galleryStore.galleryPhotoAlbums]);
	useEffect(() => {
		scrollToEvent(generalStore.currentAge);
	}, [generalStore.currentAge]);

	const getTopPaddingByAge = (age: number) => {
		if (
			!galleryStore.galleryPhotoAlbums ||
			!albumsWrapperRef.current ||
			!albumsWrapperRef.current.children.length
		)
			return;
		let topPadding = 10;
		let ageFound = false;
		for (let i = 0; i < galleryStore.galleryPhotoAlbums.length; i++) {
			const yearOfCurrentEvent = galleryStore.galleryPhotoAlbums[i].year;
			if (getAge(yearOfCurrentEvent) === age) {
				ageFound = true;
				break;
			}
			topPadding += albumsWrapperRef.current.children[i].clientHeight;
		}
		return ageFound ? topPadding : 0;
	};

	const scrollToEvent = (age: number) => {
		if (generalStore.currentAge !== age) generalStore.currentAge = age;
		if (!albumsWrapperRef.current) return;
		const targetTopPadding = getTopPaddingByAge(age);
		if (generalStore.requiredUpdateCurrentAge) {
			albumsWrapperRef.current.scrollTo({
				top: targetTopPadding,
			});
			generalStore.requiredUpdateCurrentAge = false;
		}
	};

	const getEventByPosition = (position: number) => {
		if (!albumsWrapperRef.current || !galleryStore.galleryPhotoAlbums)
			return;
		let currentEventIndex = 0;
		let currentPosition = position;
		for (let i = 0; i < galleryStore.galleryPhotoAlbums.length; i++) {
			currentPosition -=
				albumsWrapperRef.current.children[i].clientHeight;
			if (currentPosition <= 0) {
				currentEventIndex = i;
				break;
			}
		}
		return galleryStore.galleryPhotoAlbums[currentEventIndex];
	};
	const getEventAgeByPosition = (position: number) => {
		const event = getEventByPosition(position);
		if (event && event.year) {
			return getAge(event.year);
		}
	};

	const [scrollToAgeTimeout, changeScrollToAgeTimeout] = useState<
		NodeJS.Timeout | undefined
	>();
	const [stopScrollTimeout, changeStopScrollTimeout] = useState<
		NodeJS.Timeout | undefined
	>();
	const eventsScrollHandler = (e: any) => {
		if (stopScrollTimeout) clearTimeout(stopScrollTimeout);
		changeStopScrollTimeout(
			setTimeout(() => {
				let NewScrollTimeout = setTimeout(() => {
					if (e.target) {
						const age = getEventAgeByPosition(e.target.scrollTop);
						if (age && generalStore.currentAge !== age)
							generalStore.currentAge = age;
					}
				}, 100);
				clearTimeout(scrollToAgeTimeout);
				changeScrollToAgeTimeout(NewScrollTimeout);
			}, 200)
		);
	};

	return (
		<div
			className="albums_wrapper"
			ref={albumsWrapperRef}
			onScroll={eventsScrollHandler}
		>
			{galleryStore.galleryPhotoAlbums &&
				galleryStore.galleryPhotoAlbums.map((album, index) => (
					<div className="album_wrapper" key={index}>
						<GalleryPhotoAlbum album={album}></GalleryPhotoAlbum>
					</div>
				))}
		</div>
	);
}

export default observer(GalleryPhoto);
